<template>
    <div class="kit-product">
        <div>
            <figure>
                <img :src="variation ? variation.image.full_src : pData.image.full_src" />
            </figure>
            <h3 v-html="pData.title"></h3>

            <div class="kit-product__price">
                <span v-if="disallowToAdd() && !$store.getters.isOnOverview">FROM:</span>
                <var>
                    <data v-html="$store.state.currency"></data>
                    {{ priceFormat() }}
                </var>
                <span>+VAT</span>
            </div>
        </div>

        <div>
            <div class="kit-product__variants" v-if="pData.variants.length && !$store.getters.isOnOverview">
                <label v-for="variant in attributes" :key="variant.name">
                    <i class="fas fa-caret-down"></i>

                    <select ref="attributes" @change="changeVariant($event)" :name="variant.name" :data-title="variant.title">
                        <option selected disabled>Choose a {{ variant.title }}</option>

                        <option v-for="(option, x) in variant.options" :key="x" :value="option">{{ option }}</option>
                    </select>
                    
                </label>
            </div>

            <div v-if="!$store.getters.isOnOverview" class="kit-product__add">
                
                <ProductQuantity :min="getQtt().min" :max="getQtt().max" :qtt="qtt" @update="updateQtt" />

                <button class="btn btn-solid" :disabled="disallowToAdd()" @click="add()">
                    Add to kit
                </button>
            </div>

            <div v-if="$store.getters.isOnOverview">
                <ProductAttributes :product="cartItem" />
                <ProductInlineQuantity :step="cartItem.step" :pid="pid" :on-edit="onQttEdit" />
                <ProductSettings :step="cartItem.step" :pid="pid" @change-quantity="editMode" />
            </div>
        </div>

    </div>
</template>

<script>
    import ProductQuantity from './product/ProductQuantity.vue';
    import ProductAttributes from './product/ProductAttributes.vue';
    import ProductInlineQuantity from './product/ProductInlineQuantity.vue';
    import ProductSettings from './product/ProductSettings.vue';

    export default {
        name: 'Product',
        props: ['pData', 'cartItem'],
        components: {
            ProductQuantity,
            ProductAttributes,
            ProductInlineQuantity,
            ProductSettings
        },
        data() {
            return {
                qtt: this.pData.min_qty,
                selectedVariants: {},
                attributes: [],
                variation: false,
                onQttEdit: false
            }
        },
        watch: {
            pData: function () {
                // reset data
                this.qtt = this.pData.min_qty;
                this.variation = false;

                this.resetAttributes();
                this.initAttributes();
            }
        },
        computed: {
            pid() {
                return this.cartItem.variation ? this.cartItem.variation.variation_id : this.cartItem.product.id;
            }
        },
        methods: {
            changeVariant(e) {
                
                this.selectedVariants[e.target.name] = e.target.value;
                
                if (Reflect.ownKeys(this.selectedVariants).length === this.pData.attributes.length) {

                    // filter product variants
                    let result = this.pData.variants.filter(variant => {

                        const curr = [];

                        // loop selected variants
                        for (const [key, value] of Object.entries(this.selectedVariants)) {
                            curr.push(value === variant.attributes[`attribute_${key}`])
                        }

                        return !curr.includes(false);
                    })

                    if (typeof result[0] === 'undefined') return;

                    this.variation = result[0];

                    if (result[0].min_qty > this.qtt) {
                        this.qtt = result[0].min_qty;
                    }
                }
            },

            getQtt() {
                return {
                    min: this.variation ? this.variation.min_qty : this.pData.min_qty,
                    max: this.variation ? this.variation.max_qty : this.pData.max_qty
                }

            },

            updateQtt(qtt) {
                this.qtt = qtt;
            },

            disallowToAdd() {

                if (!this.pData.attributes) return false;
                
                return Reflect.ownKeys(this.selectedVariants).length != this.pData.attributes.length;
            },

            priceFormat() {
                let price = this.variation ? this.variation.display_price : this.pData.display_price;

                if (this.$store.getters.isOnOverview) {
                    price = price * this.cartItem.qtt;
                }

                return this.$store.getters.priceFormatter(price);
            },

            initAttributes() {

                this.attributes = this.pData.attributes;

                if (this.pData.attributes.length === 1) {

                    this.attributes = this.pData.attributes;

                    this.attributes[0].options = this.pData.attributes[0].options.filter(option => {

                        const opt = this.pData.variants.filter(item => {
                            return option === item.attributes[`attribute_${this.pData.attributes[0].name}`] && item.is_in_stock;
                        });

                        return opt.length;
                    })
                }
            },

            resetAttributes() {
                if (this.$refs && this.attributes && this.$refs.attributes.length) {
                    this.$refs.attributes.forEach(select => {
                        select.selectedIndex = 0;
                    });
                }
            },

            getAttributes() {
                if (this.variation && this.$refs.attributes.length) {
                    return this.$refs.attributes.map(select => {
                        return {
                            name: select.name,
                            title: select.dataset.title,
                            option: select.value
                        };
                    });
                }

                return false;
            },

            add() {
                const product = this.pData;
                const qtt = this.qtt;
                const variation = this.variation;
                let attributes = false;

                if (this.variation) {
                    attributes = this.getAttributes();
                }

                this.$store.dispatch('addToCart', {product, qtt, variation, attributes});
                // this.qtt = this.variation ? variation.min_qty : this.pData.min_qty;
            },

            editMode(mode) {
                this.onQttEdit = mode;
            }
        },

        beforeMount() {
            this.initAttributes();
        }
    }
</script>

<style lang="scss">
    .kit {
        &-product {
            padding: 10px;
            border-radius: 3px;
            border: 1px solid #E5E7EC;
            background: #FFF;
            min-height: 266px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            > div {
                width: 100%;
            }

            figure {
                position: relative;
                border-radius: 3.486px 3.486px 0px 0px;
                overflow: hidden;
                height: 131.814px;
                margin-bottom: 10px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            h3 {
                font-size: 12px;
                font-weight: 700;
                line-height: 19.462px;
                margin-bottom: 10px;
            }

            &__price {
                display: flex;
                align-items: center;
                gap: 4.42px;
                margin-bottom: 15px;

                span {
                    font-size: 8.847px;
                    text-transform: uppercase;
                }

                var {
                    color: #F97623;
                    font-size: 13.27px;
                    font-weight: 600;
                    font-style: normal;
                }
            }

            &__variants {
                padding-top: 10px;
                

                label {
                    position: relative;
                    display: block;

                    &:not(:last-child) {
                        margin-bottom: 10px;
                    }

                    i {
                        position: absolute;
                        right: 10px;
                        top: 5px;
                        font-size: 11px;
                    }

                    select {
                        width: 100%;
                        border-radius: 1px;
                        border: 0.5px solid #D2D5DE;
                        height: 26px;
                        padding: 3px 6px;
                        font-size: 11px;
                        cursor: pointer;
                        position: relative;
                        z-index: 1;
                    }
                }
            }

            &__add {
                display: flex;
                justify-content: space-between;
                padding-top: 10px;

                @media (max-width: 576px) {
                    flex-direction: column;
                    gap: 10px;
                }

                .btn {
                    height: 26px;
                    padding: 4px 21.5px;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 17.25px;

                    @media (max-width: 576px) {
                        padding: 4px 15px;
                    }
                }
            }
        }
    }
</style>